// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"dashTitle-module--Wrapper--2hYhI","Dash":"dashTitle-module--Dash--3Vf6z"};